const NS = 'SiteHeaderSearchBarWidget';
const CLS = 'siteHeaderSearchBarWidget';

export class SiteHeaderSearchBarWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$input = this.$element.find(`.${CLS}-input`);
		this.$btnClose = $(`.${CLS}-btn`);
		this.$siteHeaderWidget;
		// $(document.body).append(this.$element);

		this.$element.on(`${CLS}.open`, (event, params) => {
			this.$siteHeaderWidget = params.siteHeaderWidget; // Instance of the siteHeaderWidget
			// this.setSearchBarPosition();
			this.$input.val(null);
			this.$input.trigger('focus');
		});

		this.$btnClose.on('click', () => {
			if(this.$siteHeaderWidget && this.$siteHeaderWidget.length > 0) {
				this.$siteHeaderWidget.trigger('siteHeaderWidget.searchBar.close', {});
			}
		});

		$(document).on('keydown', function(event) {
			if(event.key == 'Escape') {
				$(`.${CLS}-btn`).trigger('click');
			}
		});

		// $(window).resize(_.debounce(() => {
		// 	this.setSearchBarPosition();
		// }, 250));
	}

	// setSearchBarPosition() {
	// 	if(this.$siteHeaderWidget && this.$siteHeaderWidget.length > 0) {
	// 		this.$element.css({
	// 			top: this.$siteHeaderWidget.offset().top + this.$siteHeaderWidget.height()
	// 		});
	// 	}
	// }
}
